export default __webpack_public_path__ + "static/media/arrow1.bf9aa34e.svg";